import { useMemo } from "react";
import { SettingsWorkspace } from "@reach/settings-workspace";

export function SettingsPage() {
  const shopDomain = useMemo(() => {
    return new URLSearchParams(window.location.search).get("shop") || "localhost";
  }, []);

  return (
    <SettingsWorkspace
      shopDomain={shopDomain}
      layoutVariant="dashboard"
      showOnboarding
    />
  );
}
